import { load } from './loader';
import * as creation from './modules/creation';
import * as lazyLoad from './modules/imageLazyload';

load([
  creation,
  lazyLoad
]);
